import { inject, Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { ReplaySubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TENANT } from '../../config/identity-provider';
import { AuthProvider, NEVER_RESOLVES } from './auth-provider';

@Injectable()
export class KeycloakAuthProvider implements AuthProvider {
  private keycloak = inject(KeycloakService);
  private authenticated = new ReplaySubject<boolean>(1);

  readonly isAuthenticated$ = this.authenticated.asObservable();

  async init(): Promise<void> {
    const loggedIn = await this.keycloak.init({
      config: {
        url: environment.KEYCLOAK_URL,
        realm: `${environment.PRODUCT_NAME}-${TENANT}`,
        clientId: environment.CLIENT_ID,
      },
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false,
      },
      enableBearerInterceptor: false,
    });
    this.authenticated.next(loggedIn);
  }

  async getAccessToken(): Promise<string> {
    try {
      await this.keycloak.updateToken(20);
    } catch {
      await this.keycloak.login();
      return NEVER_RESOLVES();
    }
    return (await this.keycloak.getToken()) ?? '';
  }

  async logout(): Promise<void> {
    await this.keycloak.logout(environment.LOGOUT_URL);
    this.authenticated.next(false);
  }
}
